import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { TenantId } from '@/types';

export interface AuthState {
  isLoading: boolean;
  isAuthenticated: boolean;
  tenantId: TenantId | null;
}

/**
 * Supabase Auth state を購読し、tenant_id を提供する
 * LIFF ログインは別途 lib/liff.ts の signInWithLine で実行
 */
export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({
    isLoading: true,
    isAuthenticated: false,
    tenantId: null,
  });

  useEffect(() => {
    let mounted = true;

    const sync = async () => {
      const { data } = await supabase.auth.getSession();
      const session = data.session;
      if (!mounted) return;
      if (!session) {
        setState({ isLoading: false, isAuthenticated: false, tenantId: null });
        return;
      }
      const tenantId = (session.user.user_metadata?.tenant_id ?? null) as TenantId | null;
      setState({ isLoading: false, isAuthenticated: true, tenantId });
    };

    sync();
    const { data: sub } = supabase.auth.onAuthStateChange(() => {
      sync();
    });
    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  return state;
}
